import React from 'react'
import { Button } from '@/ui-kit'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { ArrowBackIcon } from '@/assets/icons'
import styles from './nav-host-provider.module.scss'
import WebApp from '@twa-dev/sdk'
import { routesApp } from '@/constans/routes'

export const NavHostProvider: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const onBackBtnClick = () => navigate(-1)
    
    return (
        <div className={styles.navHost}>
            <Outlet />
            {
                !WebApp.initData.length &&
                location.pathname !== routesApp.index &&
                location.pathname !== routesApp.home &&
                <Button className={styles.backBtn} onClick={onBackBtnClick}>
                    <ArrowBackIcon />
                </Button>
            }
        </div>
    )
}
